import { logger } from '@/lib/logger';

/**
 * Last-sample-wins skew between the device clock and `meta.timestamp`. Players' phones are routinely
 * minutes wrong; a countdown driven by `Date.now()` would let them pay into a dead session.
 */

let skewMs = 0;

export function record(serverTimestamp: string): void {
  const server = Date.parse(serverTimestamp);
  if (!Number.isFinite(server)) return;
  skewMs = server - Date.now();
}

export function serverNow(): number {
  return Date.now() + skewMs;
}

export function getSkewMs(): number {
  return skewMs;
}

/** Test seam. Production code never resets skew; a new document is a new module. */
export function resetSkewForTests(): void {
  skewMs = 0;
}

/** DEV-only. A large skew is the usual cause of "it expired immediately" reports. */
export function logSkewIfLarge(): void {
  if (Math.abs(skewMs) > 5_000) {
    logger.debug('[time] device clock skew exceeds 5s', { skewMs });
  }
}
